import glamorous from 'glamorous';

export const Spinner = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '100px 0'
});
